// English or Spanish (design 4.7): the choice defaults from the browser's
// language, never from a name, and only among the languages the server offers
// (Spanish stays off until SPANISH_ENABLED, after a native speaker passes T15).
export type Language = "en" | "es";

export function defaultLanguage(offered: readonly Language[], browserLanguages: readonly string[]): Language {
  const wantsSpanish = browserLanguages.some((tag) => tag.toLowerCase().startsWith("es"));
  if (wantsSpanish && offered.includes("es")) return "es";
  return offered.includes("en") ? "en" : (offered[0] ?? "en");
}

export function browserLanguages(): string[] {
  if (typeof navigator === "undefined") return [];
  const list = navigator.languages?.length ? navigator.languages : [navigator.language];
  return list.filter((tag): tag is string => typeof tag === "string");
}
